import { FC, useRef } from "react";
import { Media } from "../../types/media";
import { useStation } from '../../contexts/StationContext';
import { generateDetailUrl } from "../../utils/urlUtils";
import SeoMeta from "../../components/Seo-Meta";
const VideoViewer: FC<{ media: Media }> = ({ media }) => {
    const { station } = useStation();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const videoId = getVideoId(media?.mediaUrl);

    const handleIframeLoad = () => {
        if (iframeRef.current) {
            iframeRef.current.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
        }
    }

    return (
        <>
            <SeoMeta
                title ={`${media.metaTitle || media?.title || ''} | Red FM ${station?.name || ''}`} 
                description={media.metaDescription || media?.description}
                keywords={media.metaKeywords}
                url={generateDetailUrl( 'all', '0', 'video',  media?.title, media?.id)}
            />
            <section className="relative flex flex-col gap-2 md:gap-4 lg:gap-6">
                <div className="md:px-10 md:pt-6 lg:px-20 lg:pt-12">
                    <iframe
                    title={`${media.title} | Red FM ${station?.name || ''}`}
                    ref={iframeRef}
                    className="peer md:rounded-[20px] w-full aspect-video"
                    src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&modestbranding=1&rel=0&showinfo=0`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    onLoad={() => handleIframeLoad()}
                >
                </iframe>
            </div>
            <div className="px-4 pb-2 md:px-10 md:pb-6 lg:px-20 lg:pb-12">
                <h1 className="text-base sm:text-xl lg:text-2xl font-kanit font-bold line-clamp-2">{media.title}</h1>
                <h3 className="text-xs md:text-lg font-kanit font-medium text-[#344054] line-clamp-2">{media.description}</h3>
            </div>
        </section>
        </>
    )
}

export default VideoViewer;

const getVideoId = (url: string): string | null => {
    if (url?.includes('youtu.be')) return url.split('/').pop()?.split('?')[0] || null;
    if (url?.includes('embed/')) return url.split('embed/')[1].split('?')[0];
    if (url?.includes('shorts/')) return url.split('shorts/')[1].split('?')[0];
    if (url?.includes('v=')) return new URLSearchParams(url.split('?')[1]).get('v');
    return null;
};